module.exports = __webpack_public_path__ + "img/check-success.601acc50.svg";